import config from "../../../../helper/config";
import APIHandler from "../../../../handlers/APIHandler";

// Function 1
export async function getAllTemplateDetails() {
  const requestOptions = {
    method: "GET",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };
  const response = await fetch(
    `${config.oat_api_url}/feedback/hierarchy/template-hierarchy`,
    requestOptions
  );
  return APIHandler.handleResponse(response);
}

// Function 2
export async function getAllFeedbacksCategory() {
  const requestOptions = {
    method: "GET",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };
  const response = await fetch(
    `${config.oat_api_url}/feedback/fb-question-category/getAll`,
    requestOptions
  );
  return APIHandler.handleResponse(response);
}

// Function 3
export async function getAllFeedbackQuestionOptions() {
  const requestOptions = {
    method: "GET",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };
  const response = await fetch(
    `${config.oat_api_url}/feedback/fb-question-option/getAll-group-qus-id`,
    requestOptions
  );
  return APIHandler.handleResponse(response);
}
// Function 4
export async function saveFeedbackAnswer(data) {
  console.log("Payload being sent:", data);

  const requestOptions = {
    method: "POST",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json", 
    },
    body: JSON.stringify(data),
  };

  const response = await fetch(
    `${config.oat_api_url}/feedback/fb-responce/add`,
    requestOptions
  );
  return APIHandler.handleResponse(response);
}
